import { ThemeProps, styled } from '@teko/ds-desktop';
import { DeleteCircleFilled } from '@teko/ds-icon';
import { default as BaseSelect, SelectProps } from 'rc-select';
import React from 'react';

interface CustomizeSelectProps extends SelectProps {
  selectInputBorderRadius?: string;
  selectItemPadding?: string;
  selectInputPadding?: string;
  selectHeight?: string;
}

export const Select: React.FC<CustomizeSelectProps> = (props) => {
  return (
    <StyledSelect
      removeIcon={
        <DeleteCircleFilled
          color="textSecondary"
          size={16}
          className="cursor-pointer"
        />
      }
      {...props}
    />
  );
};

const StyledSelect = styled(BaseSelect)<ThemeProps & CustomizeSelectProps>`
  &.rc-select {
    width: 100%;
    } // don't remove this
  }

  .rc-select-selector {
    height: ${(p) => p.selectHeight ?? '40px'};
    padding: 0 1rem;
    display: flex;
    align-items: center;
  }

  .rc-select-single {
    .rc-select-selector {
      .rc-select-selection-placeholder {
        left: 5px;
        color: ${(p) =>
          p.disabled ? p.theme.colors.disable : p.theme.colors.placeholder};
      }
      .rc-select-selection-item {
        color: ${(p) =>
          p.disabled ? p.theme.colors.border : p.theme.colors.textPrimary};
        left: 5px;
      }
    }
  }

  .rc-select-selection-placeholder,
  .rc-select-selection-item {
    font-size: 13px;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    margin-left: 0.5rem;
  }

  &.rc-select-single:not(.rc-select-customize-input) {
    .rc-select-selector {
      .rc-select-selection-search-input {
        background: ${(p) =>
          p.disabled ? p.theme.colors.background : p.theme.colors.white};
        padding: ${(p) =>
          p.selectInputPadding ?? `0.25rem 2rem 0.25rem 0.75rem`};
        height: 2.5rem;
        border-radius: ${(p) =>
          p.selectInputBorderRadius ?? p.theme.borderRadius.s};
        border: 1px solid
          ${(p) =>
            p.disabled
              ? p.theme.colors.background
              : p.theme.colors.inputBorder};
        &:hover {
          border-color: ${({ theme }) => theme.colors.neutral};
        }
        :focus,
        :focus-within {
          border-color: ${({ theme }) => theme.colors.primary};
        }
      }
    }
  }

  &.rc-select-single:not(.rc-select-customize-input) {
    .rc-select-selector {
      border-style: none !important;
    }
    .rc-select-clear {
      margin-top: 0.75rem;
    }
  }

  .rc-select-arrow {
    right: 12px;
    color: ${({ theme }) => theme.colors.black};
    display: flex;
    align-items: center;
  }

  .rc-select-clear {
    right: 13px;
    background-color: ${({ theme }) => theme.colors.white};
    display: flex;
    align-items: center;
  }

  .rc-select-dropdown {
    margin-top: 4px;
    padding: 0.25rem;
    border-radius: ${({ theme }) => theme.borderRadius.m};
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
      rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    border: none;
    background-color: ${({ theme }) => theme.colors.white};
    min-height: auto;
  }

  .rc-select-item {
    font-size: 13px;
    padding: ${(p) => p.selectItemPadding ?? `0.5rem 1rem`};
    height: 40px;
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.white};
  }

  .rc-select-item-option-active,
  .rc-select-item-option-selected {
    background-color: ${({ theme }) => theme.colors.background};
    border-radius: ${({ theme }) => theme.borderRadius.s};
  }

  .rc-virtual-list,
  .rc-virtual-list-holder,
  .rc-virtual-list-holder-inner {
    border-radius: ${({ theme }) => theme.borderRadius.m};
  }
`;
